import toJS from 'shared/components/toJS';
import { connect } from 'react-redux';
import withRouter from '../../shared/utils/WithRouter';
import ThankYou from './ThankYou';

const mapStateToProps = state => ({
	settings: state.cache.get('settings'),
});

// generate a route-aware container component
const ThankYouContainer = withRouter(connect(mapStateToProps)(toJS(ThankYou)));

export default ThankYouContainer;
export { mapStateToProps }; // for testing purposes only
